import React, {Component} from 'react';
import Data from "./Data";
import {NavLink} from "react-router-dom";

class Masters extends Component {

    render() {
        const {products,index} = this.props;

        let pic = <span className="ti-face-smile ti-3x gradient-fill ml-3"/>


        if (products.picture!==null && products.picture!==""){
            pic = <div className="circle-icon" style={{
                backgroundImage: 'url('+Data.server+'images/'+products.picture+')',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                height: '48px',
                width: '48px',
                marginLeft: '16px'
            }}/>
        }
        let ins = "";
        if (products['instruments'] !== null && products['instruments'].length > 0){
            ins = products['instruments'][0]['name'];
            for (let i = 0;i<products['instruments'].length;i++){
                if (i > 0){
                    ins += ' , '+products['instruments'][i]['name'];
                }
            }
        }

        let day = "";
        if (products['days'] !== null && products['days'].length > 0){
            day = products['days'][0]['day'];
            for (let i = 0;i<products['days'].length;i++){
                if (i > 0){
                    day += ' , '+products['days'][i]['day'];
                }
            }
        }

        return (
            <div className="col-12 item" key={index}>
                <div className="card features mt-3 round-card">
                    <div className="card-body">
                        <div className="media">
                            {pic}
                            <div className="media-body text-right">
                                <h4 className="card-title">{products['name']}</h4>
                                <small>{ins}</small>
                                <p className="card-text">{day}</p>
                            </div>
                            <div className="media-bottom mr-2" style={{
                                display: 'flex',
                                flexDirection: 'column'
                            }}>
                                {products['instruments'].map((d,i) => <img style={{width:'auto'}} key={i} className="mr-2" height="20px" width="20px" src={Data.server+"icons/"+d['icon']}/>)}
                            </div>
                        </div>
                        <div className="btn-group mt-3" role="group">
                            <NavLink to={'masters/'+products.id} type="button" className="btn btn-outline-success round-card">ثبت نام کلاس</NavLink>
                            <a href={'/masters/'+products.id} type="button" className="btn btn-outline-info round-card">اطلاعات بیشتر</a>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}


export default Masters;
